/* eslint-disable react/style-prop-object */
import React from "react";

import { svgs } from "../../../assets";

import * as S from "./styles";

const ConfirmationEmail: React.FC = () => (
  <S.Container>
    <S.Header>
      <img src={svgs.LucralizeLogo} alt="logo" />
    </S.Header>
    <S.Title>Confirmação de e-mail</S.Title>
    <S.Card>
      <S.CardImage src={svgs.ThumbsUp} alt="thumbs-up" />
      Quase lá! <br /> Enviamos um link de confirmação para o seu e-mail de
      cadastro. Ao clicar no link, você poderá dar sequência ao seu cadastro!
    </S.Card>
    <S.TermsLink to="/termos-de-uso">Termos de privacidade</S.TermsLink>
  </S.Container>
);
export default ConfirmationEmail;
